const showNotification = payload => ({
    type: 'NOTIFICATION_SHOW',
    payload
});

const hideNotification = id => ({ type: 'NOTIFICATION_HIDE', id });

export { showNotification, hideNotification };
